// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_group-module__container--35jFg"};